// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"d4e2de20","688":"c1e1f91d","707":"09592fc0","749":"a7676d12","882":"96bcadce","927":"d4e2de20"}[chunkId] + ".chunk.css";
};